import { cellRenderStatusAct } from '../../utils/functions';

const taskColumnDataGrid = [
  {
    dataField: 'taskNumber',
    dataType: 'string',
    caption: 'номер задания'
  },
  {
    dataField: 'taskDate',
    dataType: 'date',
    caption: 'дата задания'
  },
  {
    dataField: 'mark',
    dataType: 'string',
    caption: 'марка'
  },
  {
    dataField: 'profileSize',
    dataType: 'string',
    caption: 'профиль'
  },
  {
    dataField: 'readyProductSum',
    dataType: 'number',
    caption: 'ГП'
  },
  {
    dataField: 'remain',
    dataType: 'number',
    caption: 'остаток'
  },
  {
    dataField: 'semiProductSum',
    dataType: 'number',
    caption: 'ПФ'
  },
  {
    dataField: 'sku',
    dataType: 'string',
    caption: 'SKU'
  },
  {
    dataField: 'sum',
    dataType: 'number',
    caption: 'объем задания'
  },
  {
    dataField: 'taskNumId',
    dataType: 'integer',
    caption: 'id задания'
  },
  {
    dataField: 'matnrGpText',
    caption: 'Материал ГП',
    dataType: 'string'
  },
  {
    dataField: 'statusName',
    caption: 'Статус',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export default taskColumnDataGrid;
